module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_futahome-b6e58d268ac7ee8f94a1ca04ade34f78.jpg";